import { render, staticRenderFns } from "./index.vue?vue&type=template&id=028f6d25&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=028f6d25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f6d25",
  null
  
)

export default component.exports